module.exports = __webpack_public_path__ + "static/media/credits.3b361474.png";


//////////////////
// WEBPACK FOOTER
// /src/images/icons/credits.png
// module id = 347
// module chunks = 0